import { PaginationType } from "src/models/common/PaginationType.model";
import apiSlice from "./ApiSlice";

export const digitalPanApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //PENDING  REQUEST
    getDigitalPanPendingApplications: builder.query({
      providesTags: ["Digitalpan-app"],
      query: (body: PaginationType) => ({
        url: "/digital-pan/admin/list",
        method: "POST",
        body,
      }),
    }),

    // digital-pan/admin/pan_status
    // digital-pan/admin/pan_status

     // 🔹 Transaction Status API
    checkTransactionStatus: builder.mutation<any, { pancardRefId: string }>({
      query: ({ pancardRefId }) => ({
        url: "/digital-pan/admin/txn_status",
        method: "POST",
        body: { PancardrefId: pancardRefId },
      }),
    }),

    // 🔹 PAN Status API
    checkPanStatus: builder.mutation<any, { pancardRefId: string }>({
      query: ({ pancardRefId }) => ({
        url: "/digital-pan/admin/pan_status",
        method: "POST",
        body: { PancardrefId: pancardRefId },
      }),
    }),
  }),
});

export const {
  useGetDigitalPanPendingApplicationsQuery,
  useCheckTransactionStatusMutation,
  useCheckPanStatusMutation,
} = digitalPanApi;
